module.exports = __webpack_public_path__ + "img/mobile-frame.f72edc28.png";